import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "checkBoxButton"
  ]

  togglePromptValueCheck (event) {
    if (event.target.value === "on") {
      const notPromptValueButtons = this.checkBoxButtonTargets.filter(checkBoxButton => checkBoxButton.value !== "on")
      notPromptValueButtons.forEach(checkBoxButton => {
        checkBoxButton.checked = false
      })
    } else {
      const promptValueButton = this.checkBoxButtonTargets.filter(checkBoxButton => checkBoxButton.value === "on")[0]
      if (promptValueButton) {
        promptValueButton.checked = false
      }
    }
  }
}
